import React from 'react';

export default function RecordHistory(props) {
  const { histories } = props;

  return histories.map((history, i) => (
    <div key={`history-${i + 1}`}>{history.formattedContent}</div>
  ));
}
